import { ELinkedInConnectionStage, EMemberSnapshotDataDomains } from '../types/LinkedIn.ts'
import type { UserPrivateProfile, UserProfile } from './../types/User.ts'

export const LINKEDIN_DOMAIN_FIELDS: Record<
    EMemberSnapshotDataDomains,
    (keyof UserProfile | keyof UserPrivateProfile)[]
> = {
    [EMemberSnapshotDataDomains.PROFILE]: ['firstName', 'lastName', 'hobby', 'geoCountry', 'geoRegion', 'geoCity'],
    [EMemberSnapshotDataDomains.RICH_MEDIA]: ['profileImg'],
    [EMemberSnapshotDataDomains.PHONE_NUMBERS]: ['phone'],
    [EMemberSnapshotDataDomains.POSITIONS]: ['jobs'],
    [EMemberSnapshotDataDomains.ORGANIZATIONS]: ['jobs'],
    [EMemberSnapshotDataDomains.EDUCATION]: ['universities'],
    [EMemberSnapshotDataDomains.PROJECTS]: ['achievements'],
    [EMemberSnapshotDataDomains.PUBLICATIONS]: ['achievements'],
    [EMemberSnapshotDataDomains.HONORS]: ['achievements'],
    [EMemberSnapshotDataDomains.LANGUAGES]: ['languages']
}

export const LINKED_IN_FIELD_DOMAINS: Record<
    keyof UserProfile | keyof UserPrivateProfile,
    EMemberSnapshotDataDomains[]
> = Object.entries(LINKEDIN_DOMAIN_FIELDS).reduce(
    (acc, [domain, fields]) => {
        for (const field of fields) {
            if (!acc[field]) acc[field] = []
            acc[field].push(domain as EMemberSnapshotDataDomains)
        }
        return acc
    },
    {} as Record<keyof UserProfile | keyof UserPrivateProfile, EMemberSnapshotDataDomains[]>
)

export const LINKEDIN_STAGE_FIELDS: Record<ELinkedInConnectionStage, (keyof UserProfile | keyof UserPrivateProfile)[]> =
    {
        [ELinkedInConnectionStage.PUBLIC_PROFILE]: [
            ...LINKEDIN_DOMAIN_FIELDS[EMemberSnapshotDataDomains.PROFILE],
            ...LINKEDIN_DOMAIN_FIELDS[EMemberSnapshotDataDomains.RICH_MEDIA],
            ...LINKEDIN_DOMAIN_FIELDS[EMemberSnapshotDataDomains.POSITIONS],
            ...LINKEDIN_DOMAIN_FIELDS[EMemberSnapshotDataDomains.ORGANIZATIONS],
            ...LINKEDIN_DOMAIN_FIELDS[EMemberSnapshotDataDomains.EDUCATION],
            ...LINKEDIN_DOMAIN_FIELDS[EMemberSnapshotDataDomains.PROJECTS],
            ...LINKEDIN_DOMAIN_FIELDS[EMemberSnapshotDataDomains.PUBLICATIONS],
            ...LINKEDIN_DOMAIN_FIELDS[EMemberSnapshotDataDomains.HONORS],
            ...LINKEDIN_DOMAIN_FIELDS[EMemberSnapshotDataDomains.LANGUAGES]
        ],
        [ELinkedInConnectionStage.PRIVATE_PROFILE]: [
            ...LINKEDIN_DOMAIN_FIELDS[EMemberSnapshotDataDomains.PHONE_NUMBERS]
        ],
        [ELinkedInConnectionStage.TALENTBASE_PROFILE]: []
    }

export const LINKEDIN_DEFAULT_DOMAINS: EMemberSnapshotDataDomains[] = [
    EMemberSnapshotDataDomains.PROFILE,
    EMemberSnapshotDataDomains.RICH_MEDIA,
    EMemberSnapshotDataDomains.PHONE_NUMBERS,
    EMemberSnapshotDataDomains.POSITIONS,
    EMemberSnapshotDataDomains.ORGANIZATIONS,
    EMemberSnapshotDataDomains.EDUCATION,
    EMemberSnapshotDataDomains.PROJECTS,
    EMemberSnapshotDataDomains.PUBLICATIONS,
    EMemberSnapshotDataDomains.HONORS,
    EMemberSnapshotDataDomains.LANGUAGES
]

export const LINKEDIN_DEFAULT_FIELDS = LINKEDIN_DEFAULT_DOMAINS.flatMap((domain) => LINKEDIN_DOMAIN_FIELDS[domain])

export const LINKEDIN_OAUTH_CALLBACK_PATH = '/u' as const
export const LINKEDIN_OAUTH_RETURN_TO_STORAGE_KEY = 'linkedin_oauth_return_to'
